import { FC, lazy, Suspense } from "react"
import { EChartsOption } from "echarts"

export interface ChartProps {
   option: EChartsOption
   height?: number | string
   loading?: boolean
   className?: string
}

// ECharts is large and only used on chart views, so keep it out of the
// initial bundle and load it when a chart first renders.
const EChart = lazy(() => import("./EChart"))

const Chart: FC<ChartProps> = ({
   option,
   height = 320,
   loading = false,
   className,
}) => (
   <Suspense fallback={<div style={{ height }} />}>
      <EChart
         option={option}
         height={height}
         loading={loading}
         className={className}
      />
   </Suspense>
)

export default Chart
